import { render, staticRenderFns } from "./MultipleSelectUnitRate.vue?vue&type=template&id=23810620&scoped=true&"
import script from "./MultipleSelectUnitRate.vue?vue&type=script&lang=js&"
export * from "./MultipleSelectUnitRate.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSelectUnitRate.vue?vue&type=style&index=0&id=23810620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23810620",
  null
  
)

export default component.exports